<script setup>
import { useGlobalStore } from "@stores/global.js";
import Header from "@sections/global/Header.vue";
import Cart from "@components/global/Cart.vue";
import Footer from "@sections/global/Footer.vue";

const global = useGlobalStore();
</script>

<template>
	<div
		class="bg-[var(--theme-background)] text-[var(--theme-accent)] transition-colors duration-500"
	>
		<!-- <Header /> -->
		<!-- <Cart /> -->
		<router-view v-slot="{ Component, route }">
			<main class="min-h-screen">
				<component :is="Component" :key="route.path" />
			</main>
		</router-view>
		<!-- <Footer /> -->
	</div>
</template>
